export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

const trimEnv = (value?: string | null) => value?.trim() || undefined;

export const APP_TITLE = trimEnv(import.meta.env.VITE_APP_TITLE) || "悅庭牙醫 AEO 戰情中心";

export const APP_LOGO =
  trimEnv(import.meta.env.VITE_APP_LOGO) || "/logo.jpg";

export const ANALYTICS_ENDPOINT = trimEnv(import.meta.env.VITE_ANALYTICS_ENDPOINT);
export const ANALYTICS_WEBSITE_ID = trimEnv(
  import.meta.env.VITE_ANALYTICS_WEBSITE_ID
);

export const getApiBaseUrl = () => {
  if (import.meta.env.VITE_PREVIEW_ISOLATED === "true" && typeof window !== "undefined") return window.location.origin;
  // First try the injected __API_BASE_URL__ from vite.config.ts
  const injectedUrl = (globalThis as any).__API_BASE_URL__?.trim?.();
  if (injectedUrl) {
    return injectedUrl.replace(/\/$/, "");
  }

  // Then try environment variable
  const envUrl = import.meta.env.VITE_API_BASE_URL?.trim();
  if (envUrl) {
    return envUrl.replace(/\/$/, "");
  }

  // Custom Domain
  if (typeof window !== "undefined" && window.location.hostname === "yttsd.thinkwithblack.com") {
    return "https://yttsd-api.thinkwithblack.com";
  }

  // Hardcoded Worker URL for Cloudflare Pages deployment (Legacy)
  if (typeof window !== "undefined" && window.location.hostname.includes("pages.dev")) {
    return "https://yttsd-api.thinkwithblack.com";
  }

  // Fallback to current origin
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "";
};

// Generate login URL at runtime so redirect URI reflects configured API origin.
export const getLoginUrl = (redirectPath?: string) => {
  const redirect = redirectPath ?? window.location.pathname;
  const apiBaseUrl = getApiBaseUrl() || window.location.origin;
  const url = new URL("/api/oauth/google/start", apiBaseUrl);
  if (redirect) {
    url.searchParams.set("redirect", redirect);
  }
  return url.toString();
};

export const shouldLoadAnalytics = () =>
  Boolean(ANALYTICS_ENDPOINT && ANALYTICS_WEBSITE_ID);
